import { Button, StyledTableCell, Table, TableContainer } from '../../../../components';
import { Cell, Column, Row, TableBody, TableHeader } from '@react-stately/table';
import { EmptyMessage } from './EmptyMessage';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IUpdatePersonnelResponse } from '../../../../types';
import type { FC } from 'react';

interface IPersonnelTableProps {
  onRemove: (index: string) => void;
  personnel: Array<IUpdatePersonnelResponse>;
}

export const PersonnelTable: FC<IPersonnelTableProps> = ({ onRemove, personnel }) => {
  const { selectedLanguage } = useContext(LanguageSelectorContext);
  const localization = new Localization(selectedLanguage);

  return (
    <TableContainer className={'w-full'}>
      <Table selectionMode={'single'}>
        {/* HEADER */}
        <TableHeader>
          <Column>
            <StyledTableCell isHeader>{localization.translate('personnelTable.positionHeader')}</StyledTableCell>
          </Column>
          <Column>
            <StyledTableCell isHeader isNumeric>
              {localization.translate('personnelTable.timeHeader')}
            </StyledTableCell>
          </Column>
          <Column>
            <StyledTableCell isHeader isNumeric>
              {localization.translate('personnelTable.overtimeHeader')}
            </StyledTableCell>
          </Column>
          <Column>{''}</Column>
        </TableHeader>

        {/* BODY */}
        <TableBody>
          {personnel.map((p, i) => (
            <Row key={i}>
              <Cell>
                <StyledTableCell>{p.title}</StyledTableCell>
              </Cell>
              <Cell>
                <StyledTableCell isNumeric>{p.regular}</StyledTableCell>
              </Cell>
              <Cell>
                <StyledTableCell isNumeric>{p.overtime}</StyledTableCell>
              </Cell>
              <Cell>
                <StyledTableCell isNumeric>
                  <Button
                    buttonProps={{ onPress: () => onRemove(p.itemId) }}
                    size={'sm'}
                    variant={'link'}
                  >
                    {localization.translate('actions.Remove')}
                  </Button>
                </StyledTableCell>
              </Cell>
            </Row>
          ))}
        </TableBody>
      </Table>

      {/* EMPTY MESSAGE */}
      {personnel.length === 0 && (
        <EmptyMessage>{localization.translate('personnelTable.emptyMessage')}</EmptyMessage>
      )}
    </TableContainer>
  );
};